import React, { useState, useRef, useEffect } from 'react';
import {
  FaBars,
  FaTimes,
} from 'react-icons/fa';
import Logo from '../assets/img/adf_01.png';
import { Link } from 'react-scroll';
import { NavLink } from 'react-router-dom';
const Navbar = () => {
  const [nav, setNav] = useState(false);
  const sidebarRef = useRef(null);

  const handleClick = () => setNav(!nav);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        setNav(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    //bg-[#172319]
    <div className='fixed w-full lg:h-[95px] h-[90px] flex justify-between items-center px-4 bg-[#4D8850] text-[#ffffff]'>
      <div className='flex items-center'>
        <div className=' lg:pl-16 pl-5'>
          <NavLink to='/'> 
           <img src={Logo} alt='Logo' className='lg:w-[90px] lg:h-[70px] w-[65px] h-[50px] rounded-sm' />
          </NavLink>
        </div>
        {/* <div className='title'>
          <h1 className='lg:text-2xl text-lg font-bold ml-1 '>African</h1>
          <h2 className='df lg:text-xl text-sm font-semibold ml-1'>Development Foundation</h2>

        </div> */}
      </div>
      
      
      {/* menu */}
      <ul className='hidden md:flex font-roboto font-bold gap-5'>
        <li>
          <NavLink
            to='/'
            smooth={true}
            duration={500}
            className='hover:text-[#71fe88] hover:text-lg transition duration-300 cursor-pointer'
          >
            Home
          </NavLink>
        </li>
        <li>
          <NavLink
            to='/history'
            className='hover:text-[#71fe88] hover:text-lg transition duration-300 cursor-pointer'
          >
            About
          </NavLink>
        </li>
        <li>
          <NavLink
            to='/causes'
            smooth={true}
            duration={500}
            className='hover:text-[#71fe88] hover:text-lg transition duration-300 cursor-pointer'
          >
            Cause
          </NavLink>
        </li>
        <li>
          <NavLink
            to='/project' 
            smooth={true}
            duration={500}
            className='hover:text-[#71fe88] hover:text-lg transition duration-300 cursor-pointer'
          >
            Projects
          </NavLink>
        </li>
        {/* <li>
          <NavLink
            to='/governance' 
            smooth={true}
            duration={500}
            className='hover:text-[#71fe88] hover:text-lg transition duration-300 cursor-pointer'
          >
            Governance
          </NavLink>
        </li> */}
        <li>
          <Link
            to='contact' 
            smooth={true}
            duration={500}
            className='hover:text-[#71fe88] hover:text-lg transition duration-300 cursor-pointer'
          >
            Contact
          </Link>
        </li>
        <li>
    <a 
      href='https://iit.edu.ng/support/make-a-contribution' 
      target="_blank"
      rel="noopener noreferrer"
      className='bg-[#ffffff] hover:bg-[#71fe88] text-[#15381b] px-8 py-4 rounded-md transition duration-300 cursor-pointer'
    >
    Donate
  </a>
</li>
      </ul>

      {/* Hamburger */}
      <div onClick={handleClick} className='md:hidden z-10'>
        {!nav ? <FaBars /> : <FaTimes />}
      </div>

      {/* Mobile menu */}
      <ul
        ref={sidebarRef}
        className={
          !nav
            ? 'hidden'
            : 'absolute bg-[#ffffff] text-[#15381b] top-[90px] right-[-3px] w-[50%] h-[530px] flex flex-col rounded-md'
        }
      >
        <li className='py-6 text-xl mt-8 text-center'>
          <NavLink
            onClick={handleClick}
            to='/'
            smooth={true}
            duration={500}
            className='hover:underline transition duration-300 cursor-pointer'
          >
            Home
          </NavLink>
        </li>
        <li className='py-6 text-xl text-center'>
          <NavLink
            onClick={handleClick}
            to='/history'
            smooth={true}
            duration={500}
            className='hover:underline transition duration-300 cursor-pointer'
          >
            About
          </NavLink>
        </li>
        <li className='py-6 text-xl text-center'>
          <NavLink
            onClick={handleClick}
            to='/causes'
            smooth={true}
            duration={500}
            className='hover:underline transition duration-300 cursor-pointer'
          >
            Cause
          </NavLink>
        </li>
        <li className='py-6 text-xl text-center'>
          <NavLink
            onClick={handleClick}
            to='/project' // Make sure this ID matches the ID of your Projects section
            smooth={true}
            duration={500}
            className='hover:underline transition duration-300 cursor-pointer'
          >
            Projects
          </NavLink>
        </li>
        {/* <li className='py-5 text-xl text-center'>
          <NavLink
            onClick={handleClick}
            to='/governance' // Make sure this ID matches the ID of your Governance section
            smooth={true}
            duration={500}
            className='hover:underline transition duration-300 cursor-pointer'
          >
            Governance
          </NavLink>
        </li> */}
        <li className='py-6 text-xl text-center'>
          <Link
            onClick={handleClick}
            to='contact' // Make sure this ID matches the ID of your Contact section
            smooth={true}
            duration={500}
            className='hover:underline transition duration-300 cursor-pointer'
          >
            Contact
          </Link>
        </li>
        <li className='py-7 text-xl text-center'>
          <a 
            href='https://iit.edu.ng/support/make-a-contribution'  
            target="_blank"
            rel="noopener noreferrer"
            className='bg-[#15381b] hover:bg-green-400 text-white px-8 py-4 rounded-md transition duration-300 cursor-pointer'
          >
            Donate
          </a>
        </li>
      </ul>
    </div>
  );
};

export default Navbar;
